<template>
  <div id="grid-contratacion">
    <v-container grid-list-xl fluid>
      <v-layout class="d-flex pa-2">
        <div class="d-flex pa-2" xs12 sm6>
          <v-text-field
            width="300px"
            v-model="txtBusqueda"
            placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
            single-line
          ></v-text-field>
          <v-btn
            color="primary"
            @click="loadData()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>search</v-icon>Buscar</v-btn
          >
          <v-btn
            color="secondary"
            @click="limpiaBuscador()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
          >
        </div>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <div v-if="multipleSelection">
            <alert-table :count="selected.length"></alert-table>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="itemsDocumento"
              item-key="rut"
              select-all
              :pagination.sync="miPaginacion"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td>
                  <v-checkbox
                    v-if="props.item.estado == 'CONTRATADO' ? false : true"
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td class="text-xs-left" nowrap>
                  {{ props.item.rut + "-" + props.item.dv }}
                </td>
                <td class="text-xs-left">
                  {{
                    props.item.rolCapId != null
                      ? props.item.rolCapId.descripcion
                      : "-"
                  }}
                </td>
                <td class="text-xs-left">{{ props.item.cap_apto }}</td>
                <td class="text-xs-left">{{ props.item.estado }}</td>
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Ver reclutado"
                    @click="viewCandidato(props.item.id)"
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </template>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Ver reclutado
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="itemsDocumento.length"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaMasiva()"
          >Descarga</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <!-- dialogo    -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="dialog = false"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <!-- dialogo -->
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import AlertTable from "@/views/ui/AlertTable.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-contratacion",

  components: {
    LoadingDescarga,
    AlertEmpty,
    Loading,
    AlertTable,
  },
  props: {
    tipeView: "",
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      dialogLoading: false,
      singleSelect: false,
      botonDescarga: false,
      selected: [],
      loading: false,
      alerta: false,
      multipleSelection: false,
      dialog: false,
      id: "",
      idContrato: "",
      headers: [
        { text: "Rut", align: "left", sortable: false, value: "rut" },
        { text: "Rol", sortable: false, value: "cargo" },
        { text: "Resultado Capacitacion", sortable: false, value: "cap_apto" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Accion", sortable: false, value: "" },
      ],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsDocumento: [],
      idUserLogged: "",
      proceso: "",
      apto: "",
    };
  },
  watch: {
    selected: function (val) {
      if (val.length > 0) {
        this.multipleSelection = true;
      } else {
        this.multipleSelection = false;
      }
    },
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.loadData();
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadContratacionFilter() {
      this.body = {
        apto: "Apto",
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      return await axios
        .post("/candidatos/contratacionFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadContratacionFilter();
      this.miPaginacion.totalItems = this.itemsDocumento.length;

      if (this.itemsDocumento.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      loadData();
    },
    viewCandidato(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
    multipleContratacion() {
      let candidatoLst = [];
      this.selected.forEach((d) => {
        let index = candidatoLst.findIndex((x) => x == d.id);
        if (index === -1) {
          candidatoLst.push({ rut: d.rut, dv: d.dv });
        }
      });
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        candidatosList: candidatoLst,
      };
      axios
        .post("/candidatos/contrataLista", this.body)
        .then((response) => {
          return response.data;
          this.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        apto: "Apto",
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      axios
        .post("/candidatos/downloadExcelContratacion", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_CONTRATACION.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
